import { createApp } from 'vue'
import Sizes from '@/js/components/sizes'
import Buefy from './vue/buefy'
import MenuSide from './components/menu_side'

import BaseApply from './vue/BaseApply.vue'
import BaseForm from './vue/BaseForm.vue'

import FormInput from './vue/components/FormInput.vue'
import FormCheckbox from './vue/components/FormCheckbox.vue'
import FormDatepicker from './vue/components/FormDatepicker.vue'
import FormDropdown from './vue/components/FormDropdown.vue'
import FormRadio from './vue/components/FormRadio.vue'
import FormUpload from './vue/components/FormUpload.vue'

import i18n from './vue/vue-i18n'
import './vue/validators'

class CForm {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      console.log('[Beta forms online]')
      const app = document.querySelector('#vue-form')
      const menu = new MenuSide()

      if (app) {
        if (Sizes.isMobile && app.dataset.form == 'apply') return

        this.app =
          app.dataset.form == 'apply'
            ? createApp(BaseApply)
            : createApp(BaseForm)
        this.app.provide('dataset', app.dataset)

        this.app.component('form-input', FormInput)
        this.app.component('form-checkbox', FormCheckbox)
        this.app.component('form-datepicker', FormDatepicker)
        this.app.component('form-dropdown', FormDropdown)
        this.app.component('form-radio', FormRadio)
        this.app.component('form-upload', FormUpload)

        Buefy(this.app)
        this.app.use(i18n)
        this.app.mount('#vue-form')
      }
    })
  }
}

const Form = new CForm()
export default Form
